/**
 * 下拉菜单
 */
import { emptyCSSTemplateFunc } from '@hzero-front-ui/core';
var dropdownData = {
  name: 'dropdown',
  data: [{
    popupRootPadding: 0
  }],
  onlyTemplate: {
    base: emptyCSSTemplateFunc,
    pro: emptyCSSTemplateFunc
  }
};
export default dropdownData;